module.exports = __webpack_public_path__ + "img/01-5.c3c39c1c.png";